import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadUsersSuccess(users) {
  return { type: types.LOAD_USERS_SUCCESS, users };
}

export function createUserSuccess(user) {
  return { type: types.CREATE_USER_SUCCESS, user };
}

export function updateUserSuccess(user) {
  return { type: types.UPDATE_USER_SUCCESS, user };
}

export function deleteUserSuccess(user) {
  return { type: types.DELETE_USER_SUCCESS, user };
}

export function loadUsers() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'users';
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadUsersSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function loadLimitedUsers() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'users/initials';
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadUsersSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveUser(user) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'users';
    if (user.id) {
      url = baseApi + 'users/' + user.id;
      return axios
        .put(url, {
          ...user,
        })
        .then((response) => {
          dispatch(updateUserSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          username: user.username,
          initials: user.initials,
          payRate: user.payRate === 'N/A' ? null : user.payRate,
          active: true,
          resetRequired: 'Y',
        })
        .then((response) => {
          dispatch(createUserSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteUser(user) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'users/' + user.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteUserSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js